var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-flex width-100"},[_c('LineBarChart',{staticClass:"uk-flex-1",staticStyle:{"min-width":"400px"}}),_c('StatusEchart',{staticStyle:{"min-width":"300px","width":"350px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }